import DefaultDeleteCTAs from './default-delete-ctas';

export default DefaultDeleteCTAs;
